import { Link } from 'react-router-dom';
import { BTN_PRIMARY } from '../components/styles';
import usePageMeta from '../hooks/usePageMeta';

export default function NotFound() {
  usePageMeta('Page not found | RangeSafe Commercial Solutions');
  return (
    <main className="flex min-h-[80vh] items-center pt-16" data-testid="not-found">
      <div className="mx-auto max-w-shell px-5 py-24 sm:px-8">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-accentText">Error 404</p>
        <h1 className="mt-5 font-display text-6xl font-bold uppercase leading-[0.9] tracking-tight text-white sm:text-7xl">
          This page<br />doesn't exist
        </h1>
        <p className="mt-6 max-w-md text-base text-dim">
          The link may be outdated. Start from the product line or go straight to a consultation.
        </p>
        <div className="mt-10 flex flex-col gap-4 sm:flex-row">
          <Link to="/commercial" className={BTN_PRIMARY} data-testid="notfound-home-cta">Back to Commercial Home</Link>
          <Link to="/products" className="inline-flex h-12 items-center justify-center px-7 font-mono text-[11px] uppercase tracking-[0.22em] text-dim transition-colors hover:text-white" data-testid="notfound-products-cta">
            View Products →
          </Link>
        </div>
      </div>
    </main>
  );
}
